import type { ServiceTask } from '../types/appointments';

export interface UniqueTask {
	serviceTaskId: number;
	taskType: string;
}

export const getUniqueTasks = (service: ServiceTask): UniqueTask[] => {
	const seen = new Map<number, string>();
	for (const tp of service.taskPricing) {
		if (!seen.has(tp.serviceTaskId)) {
			seen.set(tp.serviceTaskId, tp.taskType);
		}
	}
	return Array.from(seen.entries()).map(([serviceTaskId, taskType]) => ({
		serviceTaskId,
		taskType,
	}));
};

export const formatTaskType = (taskType: string) =>
	taskType.charAt(0).toUpperCase() + taskType.slice(1).toLowerCase();
